// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * Header replacement functionality for Edwiser Video Format.
 *
 * @module     format_edwiservideoformat/headerreplaces
 * @copyright  Edwiser
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

define(['jquery'], function($) {
    /**
     * Init method
     */
    function init() {
        // eslint-disable-next-line no-console
        $(document).ready(function() {
            var headercontent = $(".edwiservideoformat-header-wrapper").html();
            $('#page #page-header').replaceWith(headercontent);

            // Find the bulk edit button in the new header
            var newBulkButton = $('#page #page-header .bulkEnable');
            if (newBulkButton.length > 0) {
                require(['core_courseformat/local/content/bulkedittoggler'], function(component) {
                    component.init('#' + newBulkButton.attr('id'));
                });
            }


        });
    }

    // Must return the init function.
    return {
        init: init
    };
});